import components from '../helpers/registered-components';

const getComponentById = (id) => components.get(id) || {};

export default getComponentById;
